module.exports = __webpack_public_path__ + "static/media/WhatsApp Video 2018-06-19 at 13.29.00.4c22e9e1.mp4";